/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FieldProps } from '@rjsf/utils';
import React from 'react';
import DOMPurify from 'dompurify';
export const SecretField: React.FC<FieldProps> = (props) => {
  const { registry, schema, uiSchema, required } = props;

  // Reuse the default SchemaField so the widget is still resolved from the
  const { SchemaField } = registry.fields;

  // Strip `ui:field` to prevent this custom field from being re-applied
  // recursively when we delegate back to SchemaField, and hide the default
  // label so we can render our own React label (with an icon) above it.
  const restUiSchema = { ...(uiSchema ?? {}) };
  delete restUiSchema['ui:field'];
  restUiSchema['ui:options'] = { ...(restUiSchema['ui:options'] ?? {}), label: false };

  const title = schema.title ?? props.name;

  return (
    <div className="w-full flex flex-column">
      <label className="flex align-items-center gap-2 mb-2">
        <i className="pi pi-lock" />
        <span>
          {title}
          {required ? <span> *</span> : null}
        </span>
      </label>
      <SchemaField {...props} uiSchema={restUiSchema} />
      {/* nosemgrep: gitlab.eslint.react-dangerouslysetinnerhtml */}
      {schema.description && (
        <div
          className="mb-2 text-sm text-gray-500"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(schema.description) }}
        />
      )}
    </div>
  );
};
